<div>
  <button class="mat-dialog-close" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <!-- Dialog: Header -->
  <div class="mat-dialog-header">
    <h2>{{ data.title }}</h2>
  </div>

  <!-- Dialog: Content -->
  <div class="mat-dialog-body center">
    <ecp-frametrace-visualizer [fileData]="data.payload"></ecp-frametrace-visualizer>
  </div>

  <!-- Dialog: Footer/Actions -->
  <div class="mat-dialog-footer" mat-dialog-actions>
    <div class="btn-group">
      <button cdkFocusInitial class="btn btn-primary" [mat-dialog-close]="true">
        Close and return to Frametrace Uploader
      </button>
    </div>
  </div>
</div>
